import { StyledOption, StyledIcon } from './style';
import Selectable from '../selectable';

import wholeBeanIcon from '../../assets/whole-bean.svg';
import groundIcon from '../../assets/ground.svg';

const icons = {
  wholeBean: wholeBeanIcon,
  ground: groundIcon
}

const Option = (props) => {
  let className = props.current === props.ground ? 'current' : '';

  return (
    <StyledOption className={className} onClick={props.onClick}>
      <Selectable className={className}>
        <StyledIcon>
          <img src={icons[props.icon]} alt={props.title} />
        </StyledIcon>

        {props.children}
      </Selectable>
    </StyledOption>
  )
}

export default Option;
